var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "findlawyer-order" },
    [
      _c("van-nav-bar", {
        attrs: { title: _vm.$route.meta.title },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function() {
              return [
                _c("van-icon", {
                  attrs: { name: "arrow-left", color: "#46474B", size: "20px" },
                  on: { click: _vm.back }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("div", { staticClass: "findlawyer-order-header background-white" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(" " + _vm._s(_vm.payInfo.serviceName) + "服务信息 ")
        ]),
        _c("div", { staticClass: "price" }, [
          _c("div", { staticClass: "flex van-hairline--bottom pd-bm-10" }, [
            _c("img", { attrs: { src: _vm.config.icon, alt: "" } }),
            _c(
              "div",
              { staticClass: "flex flex-column flex-space-center mg-l-10" },
              [
                _c(
                  "span",
                  {
                    staticClass: "font16",
                    staticStyle: { "font-weight": "bold" }
                  },
                  [_vm._v(_vm._s(_vm.payInfo.serviceName))]
                ),
                _c(
                  "span",
                  {
                    staticClass: "mg2 font12",
                    staticStyle: { color: "#8A8D94" }
                  },
                  [_vm._v(_vm._s(_vm.config.text || "123"))]
                )
              ]
            )
          ]),
          _c(
            "div",
            { staticClass: "flex flex-space-between flex-align-end " },
            [
              _c(
                "div",
                {
                  staticClass: "font22 flex flex-align-center mg-tp-12",
                  staticStyle: { color: "#EC5050" }
                },
                [
                  _c("span", { staticClass: "font14" }, [_vm._v("￥")]),
                  _c("span", [_vm._v(_vm._s(_vm.payInfo.servicePrice / 100))]),
                  _vm.payInfo.originalPrice
                    ? _c(
                        "span",
                        {
                          staticClass: "font12 mg-l-15 origin-price",
                          staticStyle: { color: "#8A8D94" }
                        },
                        [
                          _vm._v(
                            "原价￥" + _vm._s(_vm.payInfo.originalPrice / 100)
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _c("div", { staticClass: "font11 timer" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.payInfo.serviceCode === "CASE_ENTRUSTMENT"
                        ? "次数"
                        : "时长"
                    ) +
                    "：" +
                    _vm._s(_vm.payInfo.showServiceLength) +
                    _vm._s(
                      _vm.payInfo.serviceLengthUnit === "分"
                        ? "分钟"
                        : _vm.payInfo.serviceLengthUnit
                    ) +
                    " "
                )
              ])
            ]
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "pay-type pd-rt-16 pd-lt-16 background-white" },
        [
          _c("div", { staticClass: "line font15 flex flex-align-center" }, [
            _vm._v(" 请选择支付方式 ")
          ]),
          _vm._l(_vm.payType, function(i, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "typeline flex flex-space-between flex-align-center",
                on: {
                  click: function($event) {
                    _vm.hasOrderPayQuery.payType = i.value
                  }
                }
              },
              [
                _c("img", { attrs: { src: i.icon } }),
                _c("p", { staticClass: "flex-1" }, [
                  _vm._v(" " + _vm._s(i.label) + " ")
                ]),
                _vm.hasOrderPayQuery.payType === i.value
                  ? _c("img", {
                      staticClass: "check",
                      attrs: {
                        src: require("@/assets/imgs/common/check_circle@2x.png")
                      }
                    })
                  : _vm._e()
              ]
            )
          }),
          _vm._m(0)
        ],
        2
      ),
      _c("div", { staticClass: "fixed-wrap" }, [
        _c("div", { staticClass: "bt", on: { click: _vm.submitPay } }, [
          _vm._v(" 立即支付 ")
        ]),
        _c(
          "div",
          { staticClass: "protocol" },
          [
            _c("van-checkbox", {
              attrs: {
                "checked-color": "#2485FF",
                "icon-size": "15px",
                shape: "square"
              },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function(props) {
                    return [
                      _c("img", {
                        staticClass: "img-icon",
                        attrs: {
                          src: props.checked ? _vm.activeIcon : _vm.inactiveIcon
                        }
                      })
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.checked,
                callback: function($$v) {
                  _vm.checked = $$v
                },
                expression: "checked"
              }
            }),
            _c("p", [
              _vm._v(" 支付成功则默认同意 "),
              _c("a", { attrs: { href: _vm.protocols.law_buy_protocol } }, [
                _vm._v("《咨询服务产品》")
              ]),
              _vm._v("协议 ")
            ])
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips" }, [
      _vm._v(" 温馨提示："),
      _c("br"),
      _vm._v(" 咨询中遇到问题，可在 我的-意见反馈中进行反馈。"),
      _c("br"),
      _vm._v(" 咨询订单如有疑问，可以拨打官网热线 400-6030452"),
      _c("br")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }